import React from 'react';
import PropTypes from 'prop-types';
import { IMG, CLIPPATH, VIDEO, TEXT } from '../../models';
import {
  MultipleImages,
  MultipleObjects,
  InsetClipPath,
  VideoIcon,
  TextIcon,
} from '../../icons';

const SelectionIcon = ({ computedType }) => {
  switch (computedType) {
    case IMG:
      return <MultipleImages />;
    case CLIPPATH:
      return <InsetClipPath />;
    case VIDEO:
      return <VideoIcon />;
    case TEXT:
      return <TextIcon />;
    default:
      return <MultipleObjects />;
  }
};

SelectionIcon.propTypes = {
  computedType: PropTypes.string.isRequired,
};

export default SelectionIcon;
